import 'core-js/actual/structured-clone';
